export enum BadgeType {
  Primary,
  Error,
  Info,
}
